export const USERS_ALLOWED_TO_MARK_SALE_PAID: string[] = [
  "usr-dacb2aa3-608e-4641-bc81-642076d529ae",
  "usr-870069f0-0452-4ad7-b561-6da9cd2ab033",
  "usr-8a00a51e-d87f-4623-9206-81b993282bfd",
  "usr-71dcfd8a-6b5b-468b-8481-61551963ab49",
  "usr-ec0cefcf-be98-40f7-b158-451624e679e4",
  "usr-2467bf4d-9a53-44ee-af3c-c92a464db5be"
];


